import ApiService from '@/services/api.service';
export async function requestIdentification(request){
    const response = await ApiService.post("identification/create",request);
    return response.data;
}
export async function checkIdentificationStatus(){
    const response = await ApiService.get("identification/mine");
    return response.data;
}